import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Tabs from '../gdk/Tabs/Tabs';
import { useState, useEffect, useContext, useRef } from 'react';
import AgentProfile from '../AgentProfile/AgentProfile';
import MyAgents from '../MyAgents/MyAgents';
import AgencyBranches from '../AgencyBranches/AgencyBranches';
import AgencyProfile from '../AgencyProfile/AgencyProfile';
import AgencyGroup from '../AgencyGroup/AgencyGroup';
import ErrorsAndOmissions from '../ErrorsAndOmissions/ErrorsAndOmissions';
import { UserContext } from '../../context/UserContextProvider';
import { getAgentProfile } from '../../api/agent-profile';
import PageHeader from '../PageHeader/PageHeader';
import { ClientConfigurationContext } from "../../context/ClientConfigurationContextProvider";
import Layout from "../../components/Layout";
import { getAgencyProfileForSweeps, getAgencyProfile } from '../../api/agency-profile';
import SweepsAccountManagement from '../SweepsAccountManagement/SweepsAccountManagement';
import Loader from '../gdk/Loader';
import { GdkToasts } from '@gdk/toasts';

export default function ProfileManagement() {
    const location = useLocation();
    const user = useContext(UserContext);
    const clientConfiguration = useContext(ClientConfigurationContext);
    const navigate = useNavigate();
    const gdkOnboardingSuccessToast = useRef(null);
    const [showCancelAlert, setShowCancelAlert] = useState(false);
    const [searchParams] = useSearchParams();
    const [activeTabId, setActiveTabId] = useState(1);
    const [agencyProfile, setAgencyProfile] = useState();
    const redirectErrorEvents = ["cancel", "decline", "exception", "session_timeout", "ttl_expired"];

    const getInitialTabIndex = () => {
        if (location.state?.agencyProfile) {
            var index = Object.keys(tabContent).indexOf("Sweep Account Management") + 1;
            return index;
        }
        else if (location.state?.agentId) {
            return Object.keys(tabContent).indexOf("My Agents") + 1;
        }
        else if (location.state?.agencyId) {
            return Object.keys(tabContent).indexOf("Agency Profile") + 1;
        }
        else if (location.state?.myProfile) {
            return Object.keys(tabContent).indexOf("My Profile") + 1;
        }
        else if (location.state?.agencyBranches) {
            return Object.keys(tabContent).indexOf("Agency Branches") + 1;
        }
        else if (location.state?.agencyGroup) {
            return Object.keys(tabContent).indexOf("Agency Group") + 1;
        }
        else if (location.state?.errorsAndOmissions) {
            return Object.keys(tabContent).indexOf("Errors & Omissions") + 1;
        }

        return 1;
    }

    useEffect(() => {
        if (location.state?.agencyProfile) {
            setAgencyProfile(location.state.agencyProfile);
        } else {
            const initialTabIndex = getInitialTabIndex();
            setActiveTabId(initialTabIndex);
        }
    }, [location]);

    useEffect(() => {
        if (agencyProfile && location.state?.agencyProfile) {
            const initialTabIndex = getInitialTabIndex();
            setActiveTabId(initialTabIndex);
        }
    }, [agencyProfile]);

    const [agentProfile, setAgentProfile] = useState({
        id: user?.agentId,
        agency: {
            agencyId: user?.agencyId
        },
        firstName: user?.firstName,
        lastName: user?.lastName
    });


    const tabContent = {
        ...(clientConfiguration.enableMyProfilePage &&
            { "My Profile": <AgentProfile agentProfile={agentProfile} setAgentProfile={setAgentProfile} /> }
        ),
        ...(clientConfiguration.enableMyAgentsTab &&
            { "My Agents": <MyAgents agentId={location.state?.agentId} /> }
        ),
        ...(clientConfiguration.enableAgencyProfileTab &&
            { "Agency Profile": <AgencyProfile agencyId={user?.agencyId} /> }
        ),
        ...(clientConfiguration.enableAgencyBranchesTab &&
            { "Agency Branches": <AgencyBranches parentAgencyId={user?.agencyId} /> }
        ),
        ...(clientConfiguration.enableAgencyGroupTab &&
            { "Agency Group": <AgencyGroup /> }
        ),
        ...(clientConfiguration.enableErrorsAndOmissionsTab &&
            { "Errors & Omissions": <ErrorsAndOmissions agencyId={user?.agencyId} /> }
        ),
        ...(agencyProfile?.sweepDetails?.IsSweepsEligible && agencyProfile?.isBranch != true &&
            { "Sweep Account Management": <SweepsAccountManagement agencyProfile={agencyProfile} setAgencyProfile={setAgencyProfile} /> }
        ),
    };

    useEffect(() => {
        gdkOnboardingSuccessToast.current = new GdkToasts({
            content: "#confirmation-toast",
            floatTime: "short",
            closeBtn: true,
            baseTimer: true,
        });
    }, []);

    useEffect(() => {
        let redirectEvent = searchParams.get("event");
        let isSweepDocusign = searchParams.get("isSweepDocusign");
        let isBranchDocusign = searchParams.get("isBranchDocusign");
        let branchAgencyId = searchParams.get("branchAgencyId");
        let sweepEmail = searchParams.get("sweepEmail");

        if (!redirectEvent) {
            return;
        } else {
            let signingComplete = !redirectErrorEvents.includes(redirectEvent) ? "true" : "false";

            getAgencyProfile(user.agencyId, response => {
                if (isSweepDocusign) {
                    navigate("/email-settings", { state: { agencyProfile: response, branchProfile: null, isBranch: false, isDocusignCompleted: signingComplete, redirectFromDocusign: true, sweepEmail: sweepEmail } });
                }
                else if (isBranchDocusign) {
                    if (branchAgencyId) {
                        getAgencyProfile(branchAgencyId, branchResponse => {
                            navigate("/email-settings", { state: { agencyProfile: response, branchProfile: branchResponse, isBranch: true, isDocusignCompleted: signingComplete, redirectFromDocusign: true, sweepEmail: sweepEmail } });
                        });
                    }
                }
            });
        }
    }, []);

    useEffect(() => {
        if (!user.authorizations?.canManageProfileManagement) {
            navigate("/");
        }

        if (location.state?.enrollSuccess) {
            gdkOnboardingSuccessToast.current.show();
        }

        if (location.state?.showCancelAlert) {
            setShowCancelAlert(true);
        }
    }, [navigate]);

    useEffect(() => getAgentProfile(user?.agentId, agentProfile => setAgentProfile(agentProfile)), []);
    useEffect(() => {
        if (clientConfiguration.iaSweepsSwitch) {

            getAgencyProfileForSweeps(user?.agencyId, agencyProfile => setAgencyProfile(agencyProfile), error => setAgencyProfile([]));
        }
        else {
            setAgencyProfile([]);
        }
    }, []);

    return (
        <Layout>
            <div id="confirmation-toast" className="toasts-container">
                <div className="toasts toasts--confirmation">
                    <div>
                        <span className="icon-confirmation" />
                    </div>
                    <div role="status">
                        <div className="toasts--heading">Thanks!</div>
                        <div className="toasts--content">Your payment method has been added.</div>
                    </div>
                    <button className="toasts--close-btn icon-close">
                        <div id="toasts--base-timer" />
                    </button>
                </div>
            </div>
            <PageHeader
                header="Profile Management"
                showBottomBorder={false}
                children={
                    <>
                        <p>
                            Review information related to your profile with GEICO.<br />
                            Certain fields can be updated here, but others must be by an administrator or with the National Producer Database.
                        </p>
                        {!clientConfiguration.enableSweepOnlyMode && <a href="/" style={{ textDecoration: "none" }}>
                            <span className="geico-icon--small icon-chevron-left"></span>
                            Return to Search
                        </a>}
                    </>
                }
            />

            <div className="container margin-top">
                {showCancelAlert && (
                    <div id="alert-high" className="alert">
                        <div className="alert--high-importance">
                            <span className="icon-alert" />
                            <ul className="alert-list">
                                <li className="alert-content">
                                    <button aria-label="Close alert" className="icon-close" onClick={() => setShowCancelAlert(false)}></button>
                                    <div className="h4">Sweep Onboarding Cancelled.</div>
                                    <p>
                                        Sweep onboarding has been cancelled. Your agency has not been enrolled in sweeps.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
                {(clientConfiguration.iaSweepsSwitch && !agencyProfile) ? (
                    <Loader />
                ) : (
                    <Tabs content={tabContent} initialTabOpen={activeTabId} />
                )}
            </div>
        </Layout>
    );
};
